module.exports = vendor_b7ce6e81856854c2878e;


//////////////////
// WEBPACK FOOTER
// external "vendor_b7ce6e81856854c2878e"
// module id = 18
// module chunks = 0